import { Injectable } from '@angular/core';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { buildingCommand } from '../../command/building.command';
import { LinkBuildingDocumentCommandHandler } from './link-building-document-command-handler.service';
import { MoveToPropertyCommandHandler } from './move-to-property-command-handler.service';
import { ShowBuildingDocumentsCommandHandler } from './show-building-documents-command-handler.service';

@Injectable()
export class BuildingFormCommandHandlerResolver extends FormCommandHandlerResolver {
  constructor(
    createHandler: CreateCommandHandler,
    deleteHandler: DeleteFormCommandHandler,
    linkDocumentHandler: LinkBuildingDocumentCommandHandler,
    showDocumentHandler: ShowBuildingDocumentsCommandHandler,
    moveToPropertyHandler: MoveToPropertyCommandHandler
  ) {
    super(createHandler, deleteHandler);
    this.addHandler(buildingCommand.linkDocument, linkDocumentHandler);
    this.addHandler(buildingCommand.showDocuments, showDocumentHandler);
    this.addHandler(buildingCommand.moveToProperty, moveToPropertyHandler);
  }
}
